import script from "./CourseViewModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CourseViewModal.vue?vue&type=script&setup=true&lang=js"

import "./CourseViewModal.vue?vue&type=style&index=0&id=78c267b5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78c267b5"]])

export default __exports__